import composeInstallation from '../utils/composeInstallation'

const install = composeInstallation({
  name: 'klarnaOneSiteMessage',
  scriptId: 'klarna-one-site-message',
  install: ({ klarnaOneSiteMessageIds, locale, env}) => {
    /* eslint-disable */
    (function(v,t,n,e){
      v.klarnaOneSiteInstalled=true;var s='script',r=t.createElement(s);r.setAttribute('data-client-id', e);r.async=!0;
      r.src=n;var u=t.getElementsByTagName(s)[0];
      u.parentNode.insertBefore(r,u);})(window,document,
      `https://${locale.indexOf('US') > -1 ? 'na' : 'eu'}-library${env !== 'production' ? '.playground' : ''}.klarnaservices.com/lib.js`, klarnaOneSiteMessageIds[locale.indexOf('US') > -1 ? 'us' : 'eu']);
    /* eslint-enable */
  }
})

export { install }